var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBondDoubleExtendedGrapeSolid = function SvgBondDoubleExtendedGrapeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 76,
    viewBox: "0 0 190 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.644 64.739c14.085 13.768 36.806 14.052 51.227.63a37.335 37.335 0 0 0 5.707-6.73c5.734-8.672 15.513-13.815 25.927-13.73l2.064.018c10.091.082 19.572 5.044 25.203 13.401a37.27 37.27 0 0 0 4.958 5.924c14.185 13.772 37.008 13.916 51.368.326 15.022-14.217 15.455-37.853 1.147-52.607-14.071-14.512-37.517-15.022-52.192-1.12a37.104 37.104 0 0 0-5.655 6.797c-5.717 8.837-15.586 14.121-26.127 14.035l-1.253-.01c-10.222-.082-19.792-5.18-25.406-13.703a37.366 37.366 0 0 0-4.914-5.99C49.273-2.283 25.725-2.221 11.362 12.1c-14.558 14.522-14.517 38.176.282 52.639Z",
    fill: "#2C112D"
  })));
};
export default SvgBondDoubleExtendedGrapeSolid;